import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { DirectoryAutocompleteField } from 'modules/account/common/features';

import { Field, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { useFinancialInstrumentSection } from './useFinancialInstrumentSection';

export const FinancialInstrumentSection = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { onChangeIsin, financialInstruments, isIsinFreeSolo } =
    useFinancialInstrumentSection();

  return (
    <OrderSection
      fields={lodash.compact([
        <DirectoryAutocompleteField<{ value: string; label: string }, false>
          fullWidth
          showRequiredMark
          directorySchemaName={financialInstruments.isin.directorySchemaName}
          fieldName={financialInstruments.isin.fieldName}
          freeSolo={isIsinFreeSolo}
          label={t(
            'account.order.sections.financialInstrumentSection.fields.isin.label'
          )}
          name="financialInstrument.isin"
          placeholder={t(
            'account.order.sections.financialInstrumentSection.fields.isin.placeholder'
          )}
          onChange={onChangeIsin}
        />,
        <Field.Text
          fullWidth
          disabled={!readOnly}
          label={t(
            'account.order.sections.financialInstrumentSection.fields.securityType.label'
          )}
          name="financialInstrument.securityType"
        />,
        <Field.Text
          fullWidth
          disabled={!readOnly}
          label={t(
            'account.order.sections.financialInstrumentSection.fields.issuer.label'
          )}
          name="financialInstrument.issuer"
        />,
      ])}
      title={t('account.order.sections.financialInstrumentSection.title')}
    />
  );
};
